import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Container } from "@/components/common/Section";

export default function NotFound() {
  return (
    <div data-testid="notfound-page">
      <section className="relative overflow-hidden">
        <div className="bg-sentira-grid bg-radial-fade pointer-events-none absolute inset-0 opacity-60" />
        <Container className="relative flex min-h-[60vh] flex-col items-center justify-center py-24 text-center">
          <p className="font-mono text-sm uppercase tracking-[0.3em] text-primary">Error 404</p>
          <h1 className="mt-4 text-4xl font-semibold tracking-[-0.02em] sm:text-5xl">Page not found</h1>
          <p className="mt-4 max-w-md text-muted-foreground">
            The page you're looking for doesn't exist or has moved.
          </p>
          <Button asChild className="mt-8 bg-primary text-primary-foreground hover:bg-[hsl(173_80%_34%)]">
            <Link to="/" data-testid="notfound-home-button">Back to home</Link>
          </Button>
        </Container>
      </section>
    </div>
  );
}
